import React from "react";

const videoSrc = (url = "") => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
};

export default function BlockRenderer({ blocks = [] }) {
  return (
    <div className="space-y-6">
      {blocks.map((b, i) => {
        switch (b.type) {
          case "heading":
            return b.level === "h3"
              ? <h3 key={i} className="font-heading font-extrabold uppercase text-2xl tracking-wide text-[#171717]">{b.text}</h3>
              : <h2 key={i} className="font-heading font-extrabold uppercase text-3xl tracking-wide text-[#171717]">{b.text}</h2>;
          case "paragraph":
            return <div key={i} className="prose prose-sm sm:prose max-w-none text-[#171717]/80 leading-relaxed [&_a]:text-[#E4001C]" dangerouslySetInnerHTML={{ __html: b.html || "" }} />;
          case "image":
            return (
              <figure key={i}>
                <img src={b.url} alt={b.alt || ""} loading="lazy" className="w-full object-cover" />
                {b.caption && <figcaption className="text-xs text-gray-500 mt-2 font-tech uppercase tracking-widest">{b.caption}</figcaption>}
              </figure>
            );
          case "quote":
            return (
              <blockquote key={i} className="border-l-4 border-[#E4001C] bg-[#F5F5F5] px-6 py-5 text-lg italic text-[#171717]/80">
                {b.text}
              </blockquote>
            );
          case "list": {
            const items = (b.items || []).filter(Boolean);
            return b.style === "number"
              ? <ol key={i} className="list-decimal pl-6 space-y-2 text-[#171717]/80 text-sm sm:text-base">{items.map((it, j) => <li key={j}>{it}</li>)}</ol>
              : <ul key={i} className="list-disc pl-6 space-y-2 text-[#171717]/80 text-sm sm:text-base">{items.map((it, j) => <li key={j}>{it}</li>)}</ul>;
          }
          case "button":
            return (
              <div key={i}>
                <a href={b.url} target="_blank" rel="noopener noreferrer"
                  className="inline-flex items-center bg-[#E4001C] hover:bg-[#c00018] text-white font-tech font-semibold uppercase tracking-widest text-sm px-8 py-4 transition-colors">
                  {b.label || "Learn More"}
                </a>
              </div>
            );
          case "divider":
            return <hr key={i} className="border-gray-200" />;
          case "video": {
            const src = videoSrc(b.url);
            if (!src) return null;
            return (
              <div key={i} className="aspect-video w-full">
                <iframe src={src} title="Video" className="w-full h-full" allowFullScreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
              </div>
            );
          }
          default:
            return null;
        }
      })}
    </div>
  );
}